import { m } from "framer-motion";
import { Link } from "react-router-dom";
import { FaLinkedinIn, FaInstagram, FaFacebookF } from "react-icons/fa6";
const Footer = () => {
  return (
    <footer className="bg-[#09042C] text-white px-6 py-[72px]">
      <m.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={{
          hidden: { opacity: 0 },
          visible: {
            opacity: 1,
            transition: {
              staggerChildren: 0.2,
            },
          },
        }}
        className="max-w-[619px] mx-auto flex flex-col items-center gap-10"
      >
        {/* Logo */}
        <m.div
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: { opacity: 1, y: 0 },
          }}
          className="flex items-center gap-1"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="207"
            height="83"
            viewBox="0 0 207 83"
            fill="none"
          >
            <path
              d="M60.1254 61.6007C57.8256 61.6007 56.0187 59.7938 56.0187 57.494V24.3939C56.0187 22.1763 57.8256 20.3693 60.1254 20.3693C62.343 20.3693 64.15 22.1763 64.15 24.3939V57.494C64.15 59.7938 62.343 61.6007 60.1254 61.6007ZM60.1254 12.1559C59.0576 12.1559 57.9899 11.7452 57.2507 11.006C56.5115 10.2668 56.0187 9.19904 56.0187 8.13129C56.0187 7.06355 56.5115 5.9958 57.2507 5.25659C57.9899 4.51739 59.0576 4.02458 60.1254 4.02458C61.1931 4.02458 62.2609 4.51739 63.0001 5.25659C63.7393 5.9958 64.15 7.06355 64.15 8.13129C64.15 9.19904 63.7393 10.2668 63.0001 11.006C62.2609 11.7452 61.1931 12.1559 60.1254 12.1559Z"
              fill="white"
            />
            <path
              d="M89.4582 20.2872C100.793 20.2872 110.074 29.4862 110.074 40.9029V57.4119C110.074 59.7116 108.267 61.5186 105.967 61.5186C103.75 61.5186 101.943 59.7116 101.943 57.4119V40.9029C101.943 34.0036 96.3575 28.4185 89.4582 28.4185C82.5589 28.4185 76.9738 34.0036 76.9738 40.9029V57.4119C76.9738 59.7116 75.1669 61.5186 72.8671 61.5186C70.6495 61.5186 68.8425 59.7116 68.8425 57.4119V40.9029C68.8425 29.4862 78.1237 20.2872 89.4582 20.2872Z"
              fill="white"
            />
            <path
              d="M156.114 40.9029C156.114 40.9029 156.114 40.9029 156.114 61.5186C156.114 72.8531 146.833 82.1343 135.498 82.1343C127.531 82.1343 120.468 77.699 116.936 70.5533C115.95 68.5 116.772 66.1181 118.825 65.1325C120.796 64.1469 123.26 64.9682 124.246 66.9394C126.381 71.2926 130.652 74.003 135.498 74.003C142.315 74.003 147.818 68.5 147.983 61.765C147.983 61.6828 147.983 61.6007 147.983 57.2476C144.451 59.8759 140.18 61.5186 135.498 61.5186C124.082 61.5186 114.883 52.2374 114.883 40.9029C114.883 29.4862 124.082 20.2872 135.498 20.2872C146.833 20.2872 156.114 29.4862 156.114 40.9029ZM135.498 53.3873C142.315 53.3873 147.983 47.72 147.983 40.9029C147.983 34.0036 142.315 28.4185 135.498 28.4185C128.599 28.4185 123.014 34.0036 123.014 40.9029C123.014 47.72 128.599 53.3873 135.498 53.3873Z"
              fill="white"
            />
            <path
              d="M164.879 61.6007C162.579 61.6007 160.772 59.7938 160.772 57.494V4.02458C160.772 1.80695 162.579 0 164.879 0C167.096 0 168.903 1.80695 168.903 4.02458V57.494C168.903 59.7938 167.096 61.6007 164.879 61.6007Z"
              fill="white"
            />
            <path
              d="M202.589 20.2906C204.889 20.2906 206.696 22.0975 206.696 24.3152V65.1325C206.696 74.4137 199.057 82.0521 189.694 82.0521C183.206 82.0521 177.374 78.3561 174.499 72.5246C173.514 70.5533 174.335 68.0893 176.388 67.1037C178.36 66.1181 180.824 67.0216 181.727 68.9928C183.288 72.0318 186.327 73.9209 189.694 73.9209C194.622 73.9209 198.565 69.9784 198.565 65.1325V54.8475C196.101 56.3259 193.226 57.1472 190.105 57.1472C181.07 57.1472 173.678 49.8373 173.596 40.8025C173.596 40.7204 173.596 40.7204 173.596 40.7204V24.3152C173.596 22.0975 175.403 20.2906 177.62 20.2906C179.838 20.2906 181.645 22.0975 181.645 24.3152V40.6382C181.645 45.3199 185.505 49.0981 190.105 49.0981C194.786 49.0981 198.565 45.3199 198.565 40.6382V24.3152C198.565 22.0975 200.372 20.2906 202.589 20.2906Z"
              fill="white"
            />
            <path
              d="M31.57 42.8783C32.0206 43.3289 32.6715 43.5792 33.3223 43.5792C33.9732 43.5792 34.6241 43.3289 35.0747 42.8783C35.5253 42.4277 35.7756 41.7768 35.7756 41.1259C35.7756 40.475 35.5253 39.8242 35.0747 39.3736C34.6241 38.923 33.9732 38.6226 33.3223 38.6226C32.6715 38.6226 32.0206 38.923 31.57 39.3736C31.1194 39.8242 30.819 40.475 30.819 41.1259C30.819 41.7768 31.1194 42.4277 31.57 42.8783Z"
              fill="white"
            />
            <path
              d="M23.9157 42.8783C24.3663 43.3289 25.0172 43.5792 25.668 43.5792C26.3189 43.5792 26.9698 43.3289 27.4204 42.8783C27.871 42.4277 28.1213 41.7768 28.1213 41.1259C28.1213 40.475 27.871 39.8242 27.4204 39.3736C26.9698 38.923 26.3189 38.6226 25.668 38.6226C25.0172 38.6226 24.3663 38.923 23.9157 39.3736C23.4651 39.8242 23.1647 40.475 23.1647 41.1259C23.1647 41.7768 23.4651 42.4277 23.9157 42.8783Z"
              fill="white"
            />
            <path
              d="M16.2615 42.8783C16.7121 43.3289 17.363 43.5792 18.0139 43.5792C18.6647 43.5792 19.3156 43.3289 19.7662 42.8783C20.2168 42.4277 20.4672 41.7768 20.4672 41.1259C20.4672 40.475 20.2168 39.8242 19.7662 39.3736C19.3156 38.923 18.6647 38.6226 18.0139 38.6226C17.363 38.6226 16.7121 38.923 16.2615 39.3736C15.8109 39.8242 15.5105 40.475 15.5105 41.1259C15.5105 41.7768 15.8109 42.4277 16.2615 42.8783Z"
              fill="white"
            />
            <path
              d="M32.626 49.274C38.873 49.274 41.9964 46.2641 41.9964 40.2444C41.9964 37.0073 41.2014 34.7357 39.6113 33.4295C38.0211 32.0666 35.6927 31.3851 32.626 31.3851H20.1532C17.5892 31.3851 15.5106 29.3065 15.5106 26.7425C15.5106 24.1784 17.5892 22.0999 20.1532 22.0999H32.626C35.4088 22.0999 37.9359 22.5258 40.2076 23.3776C42.536 24.1727 44.4952 25.3653 46.0853 26.9554C47.7323 28.4888 48.9817 30.3912 49.8335 32.6629C50.7422 34.8777 51.1965 37.4049 51.1965 40.2444C51.1965 43.0839 50.7422 45.6395 49.8335 47.9111C48.9817 50.1259 47.7323 52.0568 46.0853 53.7037C44.4952 55.2938 42.536 56.5148 40.2076 57.3667C37.9359 58.2185 35.4088 58.6444 32.626 58.6444H21.3816C19.3371 58.6444 17.2927 58.8148 15.2482 59.1555C14.0564 59.3542 12.8839 59.6686 11.7307 60.0988C10.0864 60.7123 8.81225 61.9994 7.91857 63.5098L0 76.8928V39.3996C0 36.8355 2.07857 34.7569 4.64261 34.7569C7.20665 34.7569 9.28522 36.8355 9.28522 39.3996V51.8296C11.2161 50.6938 13.1754 49.9839 15.163 49.7C17.2075 49.416 19.2803 49.274 21.3816 49.274H32.626Z"
              fill="url(#paint0_linear_1_1368)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_1_1368"
                x1="2.78242"
                y1="39.4633"
                x2="20.9021"
                y2="77.534"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#E8282D" />
                <stop offset="1" stopColor="#FFA500" />
              </linearGradient>
            </defs>
          </svg>
        </m.div>

        <m.p
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: { opacity: 1, y: 0 },
          }}
          className="text-white text-center text-[18px] md:text-[20px] lg:text-[22px] leading-[120%]"
        >
          Pingly enables secure, automated appointment communication to improve
          patient engagement and operational efficiency.
        </m.p>

        <m.div
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: { staggerChildren: 0.1 },
            },
          }}
          className="flex gap-6"
        >
          {[
            { icon: FaLinkedinIn, url: "https://www.linkedin.com/in/the-pingly-8b3a583b4" },
            { icon: FaInstagram, url: "https://www.instagram.com/thepingly" },
            { icon: FaFacebookF, url: "https://x.com/Pingly477278" },
          ].map((social, index) => (
            <m.div
              key={index}
              onClick={() => window.open(social.url, "_blank")}
              variants={{
                hidden: { opacity: 0, scale: 0.5 },
                visible: { opacity: 1, scale: 1 },
              }}
              whileHover={{ scale: 1.1, rotate: 5 }}
              whileTap={{ scale: 0.95 }}
              className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center cursor-pointer hover:bg-white hover:text-[#09042C] transition-all duration-300"
            >
              <social.icon size={18} />
            </m.div>
          ))}
        </m.div>


      </m.div>
      <div className="flex flex-col md:flex-row gap-4 items-center justify-between w-full mt-[60px] lg:mt-[90px] max-w-[1600px] mx-auto">
        <m.div
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 0.5,
              transition: { duration: 1, delay: 0.5 },
            },
          }}
          className="text-white/50 text-[18px] md:text-[20px] lg:text-[22px] text-center md:text-left"
        >
          © 2026 Pingly. All Rights Reserved.
        </m.div>

        <Link to="/privacy-policy">
          <m.div
            variants={{
              hidden: { opacity: 0 },
              visible: {
                opacity: 0.5,
                transition: { duration: 1, delay: 0.5 },
              },
            }}
            className="text-white/50 text-[18px] md:text-[20px] lg:text-[22px] hover:text-white transition"
          >
            Privacy Policy
          </m.div>
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
